import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset the page scroll to the top on every route change.
 *
 * React Router doesn't do this by default in SPA mode — the browser
 * keeps the previous page's scroll position, so clicking a link at the
 * bottom of the Home page and landing halfway down the Build-Your-Own
 * page is a common footgun.
 *
 * Skips the reset when:
 *   - the URL has a `#hash` (in-page anchor links intentionally target
 *     a specific section — e.g. `/faq#delivery`)
 *   - the navigation was a browser back/forward (popstate) — let the
 *     browser restore its own scroll memory in that case
 *
 * Mount ONCE inside the Router at the top of the tree.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Respect in-page anchors
    if (hash) return;
    // Respect browser back/forward scroll restoration
    if (typeof window !== "undefined" && window.history?.scrollRestoration) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
